import React ,{ useState,useRef, useEffect } from "react";

export const useWs = (room_id) => {
    console.log(room_id,"from test websockt")
    const [isReady, setIsReady] = useState(false);
    const [val, setVal] = useState(JSON.stringify({action:null,data:null}));
    const ws = useRef(null);
    const return_state = [];
  
    useEffect(() => {
    // const room = secureLocalStorage.getItem("room")
    // const url = `ws://localhost:8000/ws/v1/${room_id}`;
    const url = `wss://backend.bedater.com/ws/v1/${room_id}`;

    const socket = new WebSocket(url);

    socket.onopen = () => setIsReady(true);
    socket.onclose = () => setIsReady(false);
    socket.onmessage = (e) => setVal(JSON.parse(e.data))
    

    ws.current = socket;
   
  
    return () => {
        socket.close();
    };
    }, []);
    
    return ws.current ? [isReady, val, ws.current.send.bind(ws.current)]:[null,val,null];
  };